module.exports = __webpack_public_path__ + "static/media/14.459fd222.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/hats/14.png
// module id = 1296
// module chunks = 0